// extracted by mini-css-extract-plugin
module.exports = {"list":"_5-z7WmHyVcbs0tLeeocCQ"};